



















































































import { instanceToPlain, plainToInstance } from "class-transformer";
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

import ConfigField from "../../../../components/ConfigField/ConfigField.vue";
import { Period } from "../types";
import { BasePeriodCondition } from "./PeriodConditions/BaseCondition/BasePeriodCondition";
import { BasePeriodConditionBuilder } from "./PeriodConditions/BaseCondition/BasePeriodConditionBuilder";
import { PeriodConditions, periodConditionsBuilders } from "./PeriodConditions/PeriodConditions";
import { PeriodConditionsTypeEnum } from "./PeriodConditions/types";

@Component({
  data() {
    return {
      periodConditionsBuilders
    }
  },
  components: {
    ConfigField
  }
})
export default class PostPeriodConditions extends Vue {
  @Prop() conditions!: Period['conditions']

  conditionsCopy: PeriodConditions | null = null

  isConditionsModalOpen = false

  currentCondition: {
    type: PeriodConditionsTypeEnum,
    data: BasePeriodCondition | null,
  } = this.defaultCurrentConditionState()

  defaultCurrentConditionState() {
    return {
      type: PeriodConditionsTypeEnum.TimeInterval,
      data: periodConditionsBuilders[PeriodConditionsTypeEnum.TimeInterval].getModel()
    }
  }

  @Emit()
  updateConditions(conditions: PeriodConditions | null) {
    if (conditions && conditions.conditions.length) {
      return instanceToPlain(conditions.conditions)
    } else {
      return null
    }
  }

  @Watch('conditionsCopy', { deep: true })
  onConditionsCopyChange(conditions: PeriodConditions | null) {
    this.updateConditions(conditions)
  }

  savePeriod() {
    const { data: condition } = this.currentCondition

    if (this.conditionsCopy && condition) {
      this.conditionsCopy.addCondition(condition)
        .then(res => {
          if (res) {
            this.isConditionsModalOpen = false
          }
        })
    }
  }

  changeCurrent(builder: BasePeriodConditionBuilder) {
    if (this.conditionsCopy) {
      this.currentCondition.type = builder.type;

      const existedCondition = this.conditionsCopy.conditionExist(builder.type)

      if (existedCondition) {
        this.currentCondition.data = builder.prepareModel(existedCondition)
      } else {
        this.currentCondition.data = builder.getModel()
      }
    }
  }

  created() {
    this.conditionsCopy = plainToInstance(PeriodConditions, { conditions: this.conditions ?? [] })
  }
}
